import { useEffect, useRef } from 'react'

export const useAudio = (props: {
  src: string
  /** 0..1 */
  volume?: number
}) => {
  const audioRef = useRef(new Audio(props.src))

  const play = async () => {
    const audio = audioRef.current
    if (!audio) {
      return
    }
    audio.volume = props.volume ?? 1
    audio.currentTime = 0
    await audio.play()
  }

  const setVolume = (volume: number) => {
    const audio = audioRef.current
    if (!audio) {
      return
    }
    audio.volume = volume
  }

  useEffect(() => {
    audioRef.current = new Audio(props.src)
  }, [props.src])

  useEffect(() => {
    if (props.volume !== undefined) {
      setVolume(props.volume)
    }
  }, [props.volume])

  return {
    play,
  }
}
